import { LabMDM } from "./lab";
import { RegexFormatAndPosition } from "./RegexFormatAndPosition";

//This model is used to define the Controls properties
export class Controls {
    _id: string;

    /** The lab where the control is located. */
    lab: LabMDM;

    /** The Control name. */
    controlConfigurationName: string;

    /** The numberOfPC count */
    numberOfPC: number;

    /** stores positiveExtractionControl List of RegexFormatAndPosition */
    positiveExtractionControl: RegexFormatAndPosition[];

    /** The numberOfNC count */
    numberOfNC: number;

    /** stores negativeExtractionControl List of RegexFormatAndPosition */
    negativeExtractionControl: RegexFormatAndPosition[];

    /** The numberOfPositivePCR count */
    numberOfPositivePCR: number;

    /** stores positivePCRControls List of RegexFormatAndPosition */
    positivePCRControls: RegexFormatAndPosition[];

    /** The numberOfNegativePCR count */
    numberOfNegativePCR: number;
    
    /** stores negativePCRControls List of RegexFormatAndPosition */
    negativePCRControls: RegexFormatAndPosition[];

    active: boolean;

    creationDate: Date;
    version: number;
    lastModifiedDate: Date;

}